import type { FC } from 'react';
import { GoToTestTT } from 'features/cabinet';
import { CabinetTitlePage } from 'components/layout';
import { LinkButton } from 'components/common';
import { Guard, usePermissionGuard } from 'features/login';
import { Add } from '@mui/icons-material';

const GoToTestPage: FC = () => {
  const { accessToViewTiktokgototest, accessToAddTiktokgototest } = usePermissionGuard();

  return (
    <Guard hasAccess={accessToViewTiktokgototest} fallback>
      <CabinetTitlePage
        title={'Go To Test'}
        endAdornment={
          <LinkButton
            to={'/cabinet/tiktok/go-to-test/add'}
            title={'Add Go To Test'}
            disabled={!accessToAddTiktokgototest}
            startIcon={<Add />}
          />
        }
      />
      <GoToTestTT />
    </Guard>
  );
};

export default GoToTestPage;
